export default (props, vars) =>
  `Congratulations, ${props?.['applicationOffer']?.['first_name']}!\nYou've been accepted!`;
